<template>
  <div class="metrics" aria-labelledby="sectionTitle">
    <template v-for="metric of metrics">
      <!-- Skeleton -->
      <div v-if="credits.counts.loading" :key="metric.title" class="metric">
        <span>{{ metric.title }}</span>
        <skeleton width="30px" height="26px" />
      </div>

      <div v-else :key="metric.title" class="metric no-action">
        <span>{{ metric.title }}</span>
        <strong>{{ metric.metric }}</strong>
      </div>
    </template>
  </div>
</template>

<script>
import Skeleton from '../../../Skeleton.vue';

export default {
  name:'Metrics',
  components: {
    Skeleton
  },

  inject: ['credits'],

  props:{
    creditType: {
      type: String,
      required: true,
      default: 'individual'
    }
  },

  computed: {
    counts() {
      if(this.creditType === 'individual')
        return this.credits.counts.individual;
      return this.credits.counts.workshop;
    },
    metrics() {
      if(this.creditType === 'individual')
        return [
          { 
            title: 'Adds', 
            metric: this.display(this.counts.adds)
          },
          {
            title: 'Successful',
            metric: this.display(-this.counts.successes)
          },
          {
            title: 'Upcoming',
            metric: this.display(-this.counts.upcomings)
          },
          {
            title: 'Late Cancel',
            metric: this.display(-this.counts.lateCancels)
          },
          {
            title: 'No Show',
            metric: this.display(-this.counts.noShows)
          },
          {
            title: 'Difference',
            metric: this.display(
              this.counts.adds 
              - this.counts.successes
              - this.counts.upcomings
              - this.counts.lateCancels
              - this.counts.noShows)
          }
        ];
      return [
        { 
          title: 'Adds', 
          metric: this.display(this.counts.adds)
        },
        {
          title: 'Successful',
          metric: this.display(-this.counts.successes + -this.counts.upcomings)
        },
        {
          title: 'Difference',
          metric: this.display(
            this.counts.adds 
            - this.counts.successes
            - this.counts.upcomings)
        }
      ];
    },
  },
  methods: {
    display(num) {
      return num < 0 ? num : `+${num}`;
    }
  }
};
</script>
